import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import nodatafound from "../../Assets/noDataFound.png";
import { getOPDHistory, getProfileStatus } from "../../api/api";
import toast from "react-hot-toast";
import { getUserMobile } from "../../utils/auth";
import { formatDate } from "../../utils/helper";

const OPDHistoryPage = () => {
  const formatDateChange = (d) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const today = new Date();
  const oneMonthAgo = new Date(today);
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  const { members } = useOutletContext();

  const [member, setMember] = useState("");

  const [fromDate, setFromDate] = useState(formatDateChange(oneMonthAgo));
  const [toDate, setToDate] = useState(formatDateChange(today));
  const [profileData, setProfileData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    fetchProfileListData();
  }, []);

  const fetchProfileListData = async () => {
    try {
      const mobile = getUserMobile();
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: "",
        mobile_no: mobile,
      };

      console.log("Profile check payload:", payload);

      // 📡 API call
      setLoading(true);
      const response = await getProfileStatus(payload);
      console.log("Profile Status Response:", response);

      if (response?.data?.status === "success") {
        setProfileData(response.data.data || {});
      } else {
        console.error("Profile fetch failed:", response?.data?.message);
        toast.error(response?.data?.message || "Unable to fetch profile data");
      }
    } catch (error) {
      console.error("Unexpected error fetching profile data:", error);
      toast.error("Something went wrong while loading your profile.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    try {
      setLoading(true);

      const mobile = getUserMobile();

      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: member || "",
        From_date: formatDate(fromDate),
        To_date: formatDate(toDate),
      };

      console.log("Booking history payload:", payload);

      const response = await getOPDHistory(payload);
      console.log("Booking history response:", response);

      if (response?.data?.status === "success") {
        const respData = response.data.data || [];
        setData(respData);
      } else {
        // handle API returning non-success status
        console.warn("Booking history fetch failed:", response?.data?.message);
        toast.error(response?.data?.message || "No booking history found");
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching booking history:", error);
      toast.error("Something went wrong while fetching booking history.");
      setData([]);
    } finally {
      setLoading(false);
    }
  };
  const statusHandler = (status) => {
    switch (status.toLowerCase()) {
      case "pending":
        return "#F6A812";
      case "completed":
        return "green";
      case "cancelled":
      case "canceled": // handle both spellings
        return "red";
      default:
        return "gray"; // fallback color
    }
  };

  return (
    <>
      <div className="container">
        <div className="profile-header">
          <h2 className="rb-title pk-title package-tagg">OPD History</h2>
        </div>
        <div className="edit-profile-form-wrapper">
          <div className="collection-history d-flex flex-wrap gap-3 align-items-end">
            <div>
              <label className="form-label collection-label">
                Choose Member
              </label>
              <select
                value={member}
                onChange={(e) => setMember(e.target.value)}
                className="form-select select-form-view"
              >
                <option value="">-- Select Member --</option>
                {profileData.map((m, index) => (
                  <option key={index} value={m.user_id}>
                    {m.PFirstName} {m.PLastName}
                  </option>
                ))}
              </select>
            </div>

            {/* From Date */}
            <div>
              <label className="form-label collection-label">From Date*</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            {/* To Date */}
            <div>
              <label className="form-label collection-label">To Date*</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            {/* Search Button */}
            <div className="btn-group-history">
              <button className="view-dash-btn" onClick={handleSearch}>
                <span className="btn-text">Search</span>
              </button>
            </div>
          </div>

          {/* Results */}
          <div className="history-area">
            {data.length === 0 ? (
              <div className="no-data">
                <img src={nodatafound} alt="No Data" />
              </div>
            ) : (
              <div
                style={{ width: "100%", overflowX: "auto", marginTop: "15px" }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontFamily: "Poppins, sans-serif",
                    boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "#21c1b3",
                          color: "#fff",
                          padding: "10px",
                          textAlign: "left",
                        }}
                      >
                        SI No.
                      </th>
                      <th
                        style={{
                          backgroundColor: "#21c1b3",
                          color: "#fff",
                          padding: "10px",
                          textAlign: "left",
                        }}
                      >
                        Appointment Id
                      </th>
                      <th
                        style={{
                          backgroundColor: "#21c1b3",
                          color: "#fff",
                          padding: "10px",
                          textAlign: "left",
                        }}
                      >
                        Doctor Name
                      </th>
                      <th
                        style={{
                          backgroundColor: "#21c1b3",
                          color: "#fff",
                          padding: "10px",
                          textAlign: "left",
                        }}
                      >
                        Appointment Date
                      </th>
                      <th
                        style={{
                          backgroundColor: "#21c1b3",
                          color: "#fff",
                          padding: "10px",
                          textAlign: "left",
                        }}
                      >
                        Appointment Time
                      </th>
                      <th
                        style={{
                          backgroundColor: "#21c1b3",
                          color: "#fff",
                          padding: "10px",
                          textAlign: "left",
                        }}
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((appt, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#f5f5f5" : "#fff",
                        }}
                      >
                        <td
                          style={{
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          {appt.appointment_id}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          {appt.doctor_name}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          {appt.AppDate}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          {appt.AppTime}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                            color:
                              appt.CStatus?.toLowerCase() === "complete"
                                ? "green"
                                : appt.CStatus?.toLowerCase() === "cancel"
                                ? "red"
                                : "#ff9800",
                            fontWeight: 600,
                          }}
                        >
                          {appt.CStatus}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OPDHistoryPage;
